import { useEffect, useState } from 'react'
import { api } from '../../../lib/api.js'
import { toast } from 'sonner'

export function useImageTypes() {
  const [types, setTypes] = useState([])
  const [loading, setLoading] = useState(true)

  const load = async () => {
    setLoading(true)
    try {
      const { data } = await api.get('/admin/image-types')
      setTypes(data.data)
    } finally { setLoading(false) }
  }

  useEffect(() => { load() }, [])

  // Optimistic toggle — flip locally, sync exact server state, revert on error
  const toggleActive = async (t) => {
    setTypes((prev) => prev.map((x) => x.id === t.id ? { ...x, is_active: !x.is_active } : x))
    try {
      const { data } = await api.patch(`/admin/image-types/${t.id}/toggle-active`)
      setTypes((prev) => prev.map((x) => x.id === t.id ? { ...x, ...data.data } : x))
    } catch (err) {
      setTypes((prev) => prev.map((x) => x.id === t.id ? { ...x, is_active: t.is_active } : x))
      toast.error(err.response?.data?.message || 'Gagal mengubah status')
    }
  }

  const remove = async (t) => {
    if (!confirm(`Hapus "${t.name}"? Hanya bisa dihapus jika tidak ada gambar terhubung.`)) return
    try { await api.delete(`/admin/image-types/${t.id}`); toast.success('Berhasil dihapus'); load() }
    catch (err) { toast.error(err.response?.data?.message || 'Gagal menghapus') }
  }

  const save = async (form) => {
    try {
      if (form.isNew) {
        await api.post('/admin/image-types', form.payload)
        toast.success('Tipe gambar berhasil dibuat')
      } else {
        await api.patch(`/admin/image-types/${form.id}`, form.payload)
        toast.success('Tipe gambar berhasil diperbarui')
      }
      load()
    } catch (err) { toast.error(err.response?.data?.message || 'Gagal menyimpan') }
  }

  return { types, loading, load, toggleActive, remove, save }
}
